var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "el-row",
          { attrs: { type: "flex" } },
          [
            _c(
              "el-col",
              { attrs: { span: 14 } },
              [
                _c(
                  "el-table",
                  {
                    attrs: {
                      "header-cell-style": _vm.headerCellStyle,
                      border: true,
                      data: _vm.features,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        label: "STT",
                        width: "50",
                        align: "center",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "Tên chức năng" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.title))]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "Tác vụ", align: "center", width: "200" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleIsOpenDialog(
                                        scope.row.key
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(scope.row.label_btn) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("CreateAttendanceAndComments", {
          attrs: { "is-open": _vm.isDialog.attendanceAndComments },
          on: { closeDialog: _vm.handleCloseDialog },
        }),
        _c("CreateCommentsWeekAndMonth", {
          attrs: { "is-open": _vm.isDialog.commentsWeekAndMonth },
          on: { closeDialog: _vm.handleCloseDialog },
        }),
        _c("DeleteDataDuplicate", {
          attrs: { "is-open": _vm.isDialog.deleteDataDuplicate },
          on: { closeDialog: _vm.handleCloseDialog },
        }),
        _c("CreateQrCode", {
          attrs: { "is-open": _vm.isDialog.createQrCode },
          on: { closeDialog: _vm.handleCloseDialog },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }